var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-entrepreneur-parallax-large",class:{ '-natural': _vm.natural }},[_c('div',{staticClass:"c-entrepreneur-parallax-large__img"},[_c('asset',{attrs:{"image":_vm.data.large_image,"cover":!_vm.natural}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }